import { memo } from "react";
import { Card, Icon, IconName } from "@repo/ping-design";
import cx from "classnames";
import "./SecondaryActionBar.scss";

export type SecondaryActionBarButton = {
  id: string;
  label: string;
  iconName: IconName;
  iconOrientation?: "left" | "right";
  onClick: () => void;
  isActive?: boolean;
};

type SecondaryActionBarProps = {
  buttons: SecondaryActionBarButton[];
  style?: React.CSSProperties;
  onButtonRef?: (buttonId: string, ref: HTMLButtonElement | null) => void;
};

const SecondaryActionBar = memo(
  ({ buttons, style, onButtonRef }: SecondaryActionBarProps) => {
    return (
      <div className="SecondaryActionBar" style={style}>
        <Card className="SecondaryActionBar__Card">
          {buttons.map((btn) => (
            <button
              key={btn.id}
              ref={(ref) => onButtonRef?.(btn.id, ref)}
              className={cx("SecondaryActionBar__Button", {
                "SecondaryActionBar__Button--Active": btn.isActive,
              })}
              onClick={btn.onClick}
            >
              {btn.iconOrientation === "left" && (
                <Icon iconName={btn.iconName} size={16} />
              )}
              <span className="SecondaryActionBar__ButtonLabel">
                {btn.label}
              </span>
              {(!btn.iconOrientation || btn.iconOrientation === "right") && (
                <Icon iconName={btn.iconName} size={16} />
              )}
            </button>
          ))}
        </Card>
      </div>
    );
  },
);

SecondaryActionBar.displayName = "SecondaryActionBar";

export default SecondaryActionBar;
